import Footer from '@/components/Footer'
import Header from '@/components/Header'
import WhatsAppFloatButton from '@/components/WhatsAppFloatButton'
import { company } from '@/lib/site-data'
import { useHead } from '@unhead/react'
import type { ReactNode } from 'react'

interface LayoutProps {
  children: ReactNode
}

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: company.legalName,
  alternateName: company.brandName,
  url: company.website,
  logo: 'https://muitamidiaofc.com.br/wp-content/uploads/2024/02/LOGO-SEM-FUNDO-MODELO-1.png',
  foundingDate: '2019',
  taxID: company.cnpj,
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Avenida Afonso Pena, 3355, Sala 1101',
    addressLocality: 'Belo Horizonte',
    addressRegion: 'MG',
    postalCode: company.postalCode,
    addressCountry: 'BR',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'Atendimento ao cliente',
    telephone: `+${company.whatsappNumber}`,
    areaServed: 'BR',
    availableLanguage: 'Portuguese',
  },
}

function Layout({ children }: LayoutProps) {
  useHead({
    script: [
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(organizationSchema),
      },
    ],
  })

  return (
    <div className="flex min-h-screen flex-col bg-[#0B0919]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppFloatButton />
    </div>
  )
}

export default Layout
